namespace GeniuzPOS.AdvPromo {
    export interface Report_Adv04Row {
        PromoCampaign?: string;
        PmGroupId?: string;
        PmId?: string;
        SalesQty?: number;
        SalesAmtBeforePromo?: number;
        PromoDisc?: number;
        SalesAmtAfterPromo?: number;
    }

    export namespace Report_Adv04Row {
        export const idProperty = 'PromoCampaign';
        export const nameProperty = 'PromoCampaign';
        export const localTextPrefix = 'AdvPromo.Report_Adv04';
        export const deletePermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';
        export const insertPermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';
        export const readPermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';
        export const updatePermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';

        export declare const enum Fields {
            PromoCampaign = "PromoCampaign",
            PmGroupId = "PmGroupId",
            PmId = "PmId",
            SalesQty = "SalesQty",
            SalesAmtBeforePromo = "SalesAmtBeforePromo",
            PromoDisc = "PromoDisc",
            SalesAmtAfterPromo = "SalesAmtAfterPromo"
        }
    }
}
